import {Fragment, FunctionComponent, useMemo} from 'react';
import {useCompareParams} from '../CompareContent';
import {CompareWithPartsResponse} from '../../../../../networking/repos/CompareRepository';
import University from '../../../../../networking/models/University';
import CompareTitle from '../../../partials/compare/CompareTitle';
import {fillParts, Part} from '../../../partials/compare/CompareTable';
import HanTable, {
    HanTableCell,
    HanTableContainer,
    HanTableHead,
    HanTableRow
} from '../../../../utils/han-table-components/HanTable';
import Breadcrumbs from '../../../../utils/Breadcrumbs';
import { compareColors } from '../../../../../config/theming';

interface Props {
    universities: University[];
    parts: CompareWithPartsResponse;
}

const CompareCostsContent: FunctionComponent<Props> = (props) => {
    const [, idString] = useCompareParams();

    const parts = useMemo(() => {
        return props.parts.reduce((parts: Part[], current) => {
            return fillParts(parts, current.active_questions);
        }, []).filter(part => part.title !== 'Comments');
    }, [props.parts]);

    const rowColors = ['mine-shaft', 'brownish-grey', 'brown-grey'];

    return (
        <>
            <CompareTitle colors={compareColors} universities={props.universities} />

            <Breadcrumbs
                breadcrumbs={
                    [
                        { name: "Home", url: "/" },
                        { name: "Universities", url: "/universities" },
                        { name: "Compare", url: `/compare/${idString}` },
                        { name: "Costs", url: `/compare/${idString}/costs` }
                    ]
                }
            />

            <div className={'compare-page__content'}>
                <h4 className={'compare-facilities-page__title'}>Costs</h4>

                <div className={'compare-page__tables'}>
                    <HanTableContainer>
                        <HanTableHead>
                            Monthly costs approximately €
                        </HanTableHead>

                        <HanTable borderOrientation={'horizontal'}>
                            { parts.map((part, i) => (
                                <Fragment key={i}>
                                    { i === parts.length - 1 &&
                                    <HanTableRow modifiers={['border-none']}>
                                        <HanTableCell modifiers={['left']} />

                                        <HanTableCell />
                                        <HanTableCell />
                                        <HanTableCell />
                                    </HanTableRow>
                                    }

                                    <HanTableRow>
                                        <HanTableCell modifiers={['left', i % 2 === 1 ? 'alabaster' : '']}>{ part.title }</HanTableCell>

                                        { part.answers.map((answer, i) => (
                                            <HanTableCell key={i} modifiers={rowColors[i]}>{ answer }</HanTableCell>
                                        )) }
                                    </HanTableRow>
                                </Fragment>
                            )) }
                        </HanTable>
                    </HanTableContainer>
                </div>
            </div>
        </>
    );
};

export default CompareCostsContent;
